import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { View, Row, CTALink, InlineLink } from 'modules/styled';
import PropTypes from 'prop-types';
import PostButtons from 'modules/post/vote-buttons/postbuttons.container';
import { copyToClipBoard } from 'app/utils/text';
import { getPostUrl } from 'app/utils/post';

PostButtonRow.propTypes = {
  post: PropTypes.object,
  setActiveComment: PropTypes.func,
  parentPost: PropTypes.object,
};

export default memo(PostButtonRow);

function PostButtonRow(props) {
  const { post, setActiveComment, parentPost } = props;
  const screenSize = useSelector((state) => state.navigation.screenSize);
  const community = useSelector((state) => state.auth.community);

  const url = 'https://relevant.community' + getPostUrl(community, post);
  const localUrl = getPostUrl(community, post);
  const hideHorizontalButton = screenSize === 0 && !post?.parentPost;

  return (
    <Row
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
      // stop-gap to avoid the page dimenisons breaking on deeply nested comments
    >
      {!hideHorizontalButton ? (
        <View sx={{ mr: 4 }}>
          <PostButtons {...props} post={post} horizontal />
        </View>
      ) : null}
      <Row>
        <InlineLink
          hu
          to={setActiveComment ? '#' : localUrl}
          inline
          authrequired={true}
          onClick={(e) => {
            if (!setActiveComment) return;
            e.preventDefault();
            setActiveComment(post.id);
          }}
        >
          <CTALink sx={{ mr: 3, color: 'blue' }}>
            {parentPost ? 'Reply' : 'Comment'}
          </CTALink>
        </InlineLink>
        <InlineLink
          hu
          to="#"
          authrequired={true}
          inline
          onClick={(e) => {
            e.preventDefault();
            copyToClipBoard(url);
          }}
        >
          <CTALink sx={{ color: 'blue' }}>Share</CTALink>
        </InlineLink>
      </Row>
    </Row>
  );
}
